import React from "react";
import ResultsChart from "./ResultsChart";
import { Grid, Box, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import ReportIcon from "@mui/icons-material/Report";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./ResultsAccordion.css";
const ResultsTable = (props) => {
  const {
    noOf1dSuccess,
    noOf1dFailed,
    noOf2dSuccess,
    noOf2dFailed,
    noOfOcrFailed,
    noOfOcrSuccess,
  } = props;
  return (
    <>
      <Typography size="md" fontWeight="bold" component="p" gutterBottom>
        &nbsp;&nbsp;&nbsp;Summary
      </Typography>
      <Grid className="grid-example" container >
        <Grid item sm={2} xs={6}>
          <Box p={2}>
            {" "}
            <ResultsChart
              chartHeader={"1D Barcode Label"}
              success={noOf1dSuccess}
              failed={noOf1dFailed}
            />
          </Box>
        </Grid>
        <Grid item sm={2} xs={6}>
          <Box p={2} sx={{ "margin-top": "5rem" }}>
            <TableContainer variant="elevated">
              <Table>
                <TableBody>
                  <TableRow>
                    <Box p={1}>
                      <TableCell>
                        <CheckCircleIcon color="success" />
                        {noOf1dSuccess} Compliant
                      </TableCell>
                    </Box>
                    <Box p={1}>
                      {" "}
                      <TableCell>
                        <ReportIcon sx={{ color: "#c21020" }} />
                        {noOf1dFailed} Not Compliant
                      </TableCell>
                    </Box>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
        <Grid item sm={2} xs={6}>
          <Box p={2}>
            {" "}
            <ResultsChart
              chartHeader={"2D Data Matrix Code Label"}
              success={noOf2dSuccess}
              failed={noOf2dFailed}
            />
          </Box>
        </Grid>
        <Grid item sm={2} xs={6}>
          <Box p={2} sx={{ "margin-top": "5rem" }}>
            <TableContainer variant="elevated">
              <Table>
                <TableBody>
                  <TableRow>
                    <Box p={1}>
                      <TableCell>
                        <CheckCircleIcon color="success" />
                        {noOf2dSuccess} Compliant
                      </TableCell>
                    </Box>
                    <Box p={1}>
                      <TableCell>
                        <ReportIcon sx={{ color: "#c21020" }} />
                        {noOf2dFailed} Not Compliant
                      </TableCell>
                    </Box>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
        <Grid item sm={2} xs={6}>
          <Box p={2}>
            {" "}
            <ResultsChart
              chartHeader={"OCR"}
              success={noOfOcrSuccess}
              failed={noOfOcrFailed}
            />
          </Box>
        </Grid>
        <Grid item sm={2} xs={6}>
          <Box p={2} sx={{ "margin-top": "5rem" }}>
            <TableContainer variant="elevated">
              <Table>
                <TableBody>
                  <TableRow>
                    <Box p={1}>
                      <TableCell>
                        <CheckCircleIcon color="success" />
                        {noOfOcrSuccess} Compliant
                      </TableCell>
                    </Box>
                    <Box p={1}>
                      <TableCell>
                        <ReportIcon sx={{ color: "#c21020" }} />
                        {noOfOcrFailed} Not Compliant
                      </TableCell>
                    </Box>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ResultsTable;
